import {ObjectBuilder} from '@gongxigames/framework/core';
import {Rectangle, Sprite} from 'pixi.js';

export type MenuBarButtonButtonConfig = {
    icon: string;
    active?: boolean;
    action?: () => void;
    width: number;
    height: number;
};

export class MenuBarButton {
    public readonly container: Sprite = new Sprite();

    private _icon?: Sprite;
    private _config?: MenuBarButtonButtonConfig;

    constructor(private _objectBuilder: ObjectBuilder) {
        this.container.name = 'Button';
        this.container.interactive = true;
        this.container.on('click', () => this._config!.action?.());
        this.container.on('tap', () => this._config!.action?.());
    }

    public update(config: MenuBarButtonButtonConfig): void {
        const oldConfig = this._config;

        this._config = config;

        if (oldConfig?.icon !== this._config.icon && this._icon) {
            this.container.removeChild(this._icon);
            delete this._icon;
        }

        if (!this._icon) {
            this._icon = this._objectBuilder.buildImage({src: config.icon});
            this.container.name = 'Button:' + this._config?.icon;
            this.container.addChild(this._icon);
        }

        this.updateIcon();

        this.container.hitArea = new Rectangle(0, 0, config.width, config.height);
    }

    private updateIcon(): void {
        const {active, width, height} = this._config!;
        const icon = this._icon!;

        icon.tint = active ? 0xffff00 : 0xffffff;
        icon.anchor.set(0.5, 0.5);
        icon.position.set(width / 2, height / 2);
        icon.scale.set(1);

        const scaleHorizontal = width / icon.width;
        const scaleVertical = height / icon.height;
        const scale = Math.min(1, scaleHorizontal, scaleVertical);

        icon.scale.set(scale);
    }
}
